module.exports = __webpack_public_path__ + "static/cultures-dbfd6dc148aa8fa21b511846e3c9e832.png";